import { render, staticRenderFns } from "./SafetyIsland.vue?vue&type=template&id=620ccd37&scoped=true"
import script from "./SafetyIsland.vue?vue&type=script&lang=js"
export * from "./SafetyIsland.vue?vue&type=script&lang=js"
import style0 from "./SafetyIsland.vue?vue&type=style&index=0&id=620ccd37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ccd37",
  null
  
)

export default component.exports